module.exports = __webpack_public_path__ + "static/media/trump-johnson-trudeau-versus-health-sentiment.b77dd9b8.png";